import React from 'react';
import { Pie } from '@ant-design/charts';
import { Typography } from 'antd';
import PageTopWrapper from './page-top-wrapper';

interface IProps {
    dataReport: any;
}

const CountProductPie: React.FC<IProps> = ({ dataReport = {} }) => {
    const config = {
        appendPadding: 10,
        data: dataReport?.listCountProduct || [],
        angleField: 'total',
        colorField: 'name',
        radius: 1,
        innerRadius: 0.64,
        meta: {
            value: {
                formatter: function formatter(v: any) {
                    return ''.concat(v, ' SP');
                },
            },
        },
        label: {
            type: 'inner',
            offset: '-50%',
            style: { textAlign: 'center' },
            autoRotate: false,
            content: '{value}',
        },
        statistic: {
            title: {
                offsetY: -4,
            },
        },
        interactions: [{ type: 'element-selected' }, { type: 'element-active' }, { type: 'pie-statistic-active' }],
    };
    return (
        <div>
            <PageTopWrapper leftContent={<Typography.Title level={5}>Số lượng sản phẩm đã bán</Typography.Title>} />
            <Pie {...config} className="chart-status" />
        </div>
    );
};

export default CountProductPie;
